import React from 'react'
import { Typography } from '@taglivros/tag-components'
import * as S from './styles'
import PeekCarousel from '@site/components/molecules/PeekCarousel'
import { StrapiFile } from '@shared/utils/strapi/strapi.types'


const CarouselSection: React.FC<CarouselSection.Props> = ( { homeCarousel } ): React.ReactElement => {
  return (
    <S.Container>
      <S.TextAreaContainer>
        <S.TextContainer>
          <Typography
            as="h2"
            variant="customText"
            fontFamily="robotoSlab"
            fontSizeDesktop="title-m"
            fontSizeMobile="title-p"
            color="GREY-700-TXT"
          >
            { homeCarousel.title }
          </Typography>
        </S.TextContainer>
        <S.TextContainer marginTop="8px">
          <Typography
            as="p"
            variant="customText"
            fontFamily="notoSans"
            fontSizeDesktop="xs"
            fontSizeMobile="xs"
            fontWeight="m"
            color="GREY-700-TXT"
          >
            { homeCarousel.subtitle }
          </Typography>
        </S.TextContainer>
      </S.TextAreaContainer>
      <S.CarouselContainer>
        <PeekCarousel
          images={ homeCarousel.images }
          autoPlay={ homeCarousel.autoPlay }
        />
      </S.CarouselContainer>
    </S.Container>
  )
}

namespace CarouselSection {
  export interface Props {
    homeCarousel: {
      title: string
      subtitle: string
      autoPlay: boolean
      images: Array<StrapiFile & {localFile?: any}>
    }
  }
}

export default CarouselSection
